import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { catchError, map, of } from 'rxjs';
import { IntegrationV2EndpointsStore } from '../../features/integration-v2/services/integration-v2-endpoints.store';
import { ToastService } from '../services/toast.service';

const UNAVAILABLE_MESSAGE = 'This document endpoint is not available for your tenant.';

export const assignedEndpointGuard: CanActivateFn = (route) => {
  const store = inject(IntegrationV2EndpointsStore);
  const router = inject(Router);
  const toast = inject(ToastService);
  const slug = route.queryParamMap.get('slug')?.trim() ?? '';

  return store.ensureLoaded().pipe(
    map(() => {
      if (!slug) return true;
      if (store.findBySlug(slug)) return true;
      toast.error(UNAVAILABLE_MESSAGE);
      return router.createUrlTree(['/integration']);
    }),
    catchError(() => {
      toast.error(UNAVAILABLE_MESSAGE);
      return of(router.createUrlTree(['/integration']));
    }),
  );
};
